import { translate } from "./Translation";

export const formatShortInstallationDate = (value, locale = "fr-FR") => {
  if (!value) return null;

  const date = new Date(`${String(value).slice(0, 10)}T00:00:00`);
  if (Number.isNaN(date.getTime())) return null;

  return date.toLocaleDateString(locale, {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
  });
};

export const getSinceInstallationLabel = (value, lang, locale) => {
  const formattedDate = formatShortInstallationDate(value, locale);
  if (!formattedDate) return translate("since_beginning", lang);

  return translate("since_installation", lang, { date: formattedDate });
};
